import {
    GET_BILL_LIST,
    GET_BILL_LIST_ERROR,
    GET_BILL_LIST_RESET,
    GET_BILL_LIST_SUCCESS,
    GET_RETURN_BILL_LIST,
    GET_RETURN_BILL_LIST_ERROR,
    GET_RETURN_BILL_LIST_RESET,
    GET_RETURN_BILL_LIST_SUCCESS,
} from "../actions/billAction"

const initialState = {
    getBillListData: {},
    getReturnBillListData: {},

    getReturnBillListLoading: false,
    getReturnBillListError: null,
}

export default function billReducer(state = initialState, action) {
    switch (action.type) {

        case GET_BILL_LIST:
            return {
                ...state,
                getBillListLoading: true,
                getBillListError: null,
            }

        case GET_BILL_LIST_SUCCESS:
            return {
                ...state,
                getBillListLoading: false,
                getBillListData: action.payload.success,
            }

        case GET_BILL_LIST_ERROR:
            return {
                ...state,
                getBillListLoading: false,
                getBillListError: action.payload.error,
                getBillListData: [],
            }

        case GET_BILL_LIST_RESET:
            return {
                ...state,
                getBillListLoading: false,
                getBillListError: null,
                getBillListData: {},
            }

        case GET_RETURN_BILL_LIST:
            return {
                ...state,
                getReturnBillListLoading: true,
                getReturnBillListError: null,
            }

        case GET_RETURN_BILL_LIST_SUCCESS:
            return {
                ...state,
                getReturnBillListLoading: false,
                getReturnBillListData: action.payload.success,
            }

        case GET_RETURN_BILL_LIST_ERROR:
            return {
                ...state,
                getReturnBillListLoading: false,
                getReturnBillListError: action.payload.error,
                getReturnBillListData: [],
            }

        case GET_RETURN_BILL_LIST_RESET:
            return {
                ...state,
                getReturnBillListLoading: false,
                getReturnBillListError: null,
                getReturnBillListData: {},
            }

        default:
            return state
    }
}